import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { getPaymentModelSuppliers } from '~/services-v2/payment-model-api/payment-model-api'
import { conventionalNameFormat } from '~/utils/formatter/name'

export default function useSuppliers() {
  const queryFn = async () => {
    const suppliers = await getPaymentModelSuppliers()
    return suppliers.map(supplier => ({
      ...supplier,
      company_name: conventionalNameFormat(supplier.company_name ?? ''),
    }))
  }

  return useQuery({
    queryFn,
    queryKey: queryKeys.PAYMENT_MODEL.SUPPLIERS,
    retry: 3,
    staleTime: 1000 * 60 * 1,
  })
}
